/**
 * Optimiciti API Specification
 * Welcome to the Beta release of the Optimiciti API. This API allows registered users to make direct calls to our optimization solvers via a web request.  Use of the API requires acceptance of our terms of service.  Some useful links: - [Optimiciti Homepage](https://optimiciti.com) - [Optimiciti API Access Plans](https://optimiciti.com/pricing)
 *
 * The version of the OpenAPI document: 0.0.2
 * Contact: api@optimiciti.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import CostAdderVehicleTypeAddersInner from './CostAdderVehicleTypeAddersInner';

/**
 * The CostAdder model module.
 * @module model/CostAdder
 * @version 0.0.2
 */
class CostAdder {
    /**
     * Constructs a new <code>CostAdder</code>.
     * This schema defines a cost adder to apply to the base cost metric (duration or distance) to calculate the final travel cost.
     * @alias module:model/CostAdder
     * @param vehicleTypeDependence {Boolean} Whether the cost adder should depend on the vehicle type. If true, then the cost adder will be applied separately for each vehicle type. If false, then the cost adder will be applied based on the first vehicle type in the VehicleTypes list.
     */
    constructor(vehicleTypeDependence) { 
        
        CostAdder.initialize(this, vehicleTypeDependence);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj, vehicleTypeDependence) { 
        obj['vehicleTypeDependence'] = vehicleTypeDependence || false;
        obj['baseAdder'] = 0.0;
    }

    /**
     * Constructs a <code>CostAdder</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/CostAdder} obj Optional instance to populate.
     * @return {module:model/CostAdder} The populated <code>CostAdder</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new CostAdder();

            if (data.hasOwnProperty('vehicleTypeDependence')) {
                obj['vehicleTypeDependence'] = ApiClient.convertToType(data['vehicleTypeDependence'], 'Boolean');
            }
            if (data.hasOwnProperty('baseAdder')) {
                obj['baseAdder'] = ApiClient.convertToType(data['baseAdder'], 'Number');
            }
            if (data.hasOwnProperty('vehicleTypeAdders')) {
                obj['vehicleTypeAdders'] = ApiClient.convertToType(data['vehicleTypeAdders'], [CostAdderVehicleTypeAddersInner]);
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>CostAdder</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>CostAdder</code>.
     */
    static validateJSON(data) {
        // check to make sure all required properties are present in the JSON string
        for (const property of CostAdder.RequiredProperties) {
            if (!data.hasOwnProperty(property)) {
                throw new Error("The required field `" + property + "` is not found in the JSON data: " + JSON.stringify(data));
            }
        }
        if (data['vehicleTypeAdders']) { // data not null
            // ensure the json data is an array
            if (!Array.isArray(data['vehicleTypeAdders'])) {
                throw new Error("Expected the field `vehicleTypeAdders` to be an array in the JSON data but got " + data['vehicleTypeAdders']);
            }
            // validate the optional field `vehicleTypeAdders` (array)
            for (const item of data['vehicleTypeAdders']) {
                CostAdderVehicleTypeAddersInner.validateJSON(item);
            };
        }

        return true;
    }


}

CostAdder.RequiredProperties = ["vehicleTypeDependence"];

/**
 * Whether the cost adder should depend on the vehicle type. If true, then the cost adder will be applied separately for each vehicle type. If false, then the cost adder will be applied based on the first vehicle type in the VehicleTypes list.
 * @member {Boolean} vehicleTypeDependence
 * @default false
 */
CostAdder.prototype['vehicleTypeDependence'] = false;

/**
 * The adder to apply to the base cost metric (duration or distance) to calculate the final travel cost.
 * @member {Number} baseAdder
 * @default 0.0
 */
CostAdder.prototype['baseAdder'] = 0.0;

/**
 * @member {Array.<module:model/CostAdderVehicleTypeAddersInner>} vehicleTypeAdders
 */
CostAdder.prototype['vehicleTypeAdders'] = undefined;






export default CostAdder;

